import client from './client';

// Nguồn dữ liệu pmbox.me — bản clone của SocSon. Dùng CHUNG endpoint /api/socson/* nhưng gắn source='pmbox'
// (backend đọc source từ query cho GET, từ body cho POST). Token/dữ liệu tách riêng theo nguồn.
const Q = { params: { source: 'pmbox' } };

export const pmboxStatus = () => client.get('/socson/status', Q).then((r) => r.data);
export const setPmboxToken = (token, station) =>
  client.post('/socson/token', { token, station, source: 'pmbox' }).then((r) => r.data);
export const pmboxTest = (signal) => client.get('/socson/test', { params: { source: 'pmbox' }, signal }).then((r) => r.data);
export const pmboxRelogin = () => client.post('/socson/relogin', { source: 'pmbox' }).then((r) => r.data);
// Quét danh sách khách hàng pmbox (chạy nền; poll getScanStatus() key 'pmbox:customers').
export const scanPmboxCustomers = () => client.post('/socson/scan/customers', { source: 'pmbox' }).then((r) => r.data);
// Cập nhật hồ sơ nhân viên pmbox (khớp theo mã NV) — phục vụ map sale -> NV khi chat với KH pmbox.
export const syncPmboxStaff = (signal) => client.post('/socson/sync-staff', { source: 'pmbox' }, { signal }).then((r) => r.data);
